import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteGroup = api(async function deleteGroup({ id, groupId }) {
    if (!id || !groupId) return null
    return mutate(
        gql`
            mutation DeleteGroup($id: String!, $groupId: String!) {
                deleteGroup(id: $id, groupId: $groupId)
            }
        `,
        { id, groupId },
        { returns: "deleteGroup" }
    )
})
